import { createContext } from 'react';

const CashOutsContext = createContext();

export default CashOutsContext;